import { I18n } from '@calendly/i18n';
import { Link } from '@calendly/ui/components/link';
import classNames from 'classnames';
import { forwardRef } from 'react';
const wrapperCss = "w1pk3yqt";
const Wrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(wrapperCss, props.className)} />;
});
export const SingleMembership = ({
  membership,
  slug
}) => <Wrapper>
    <Link variant="subtle" href={`/event_types/user/${membership.user_id}`} target="_blank" rel="noopener noreferrer">
      {membership.name}
    </Link>
    {' '}
    {I18n.t('publisher.organization.managed_event_types.assign.slug_conflict.single_membership_text')}
    {' '}
    <strong>
      /
      {slug}
    </strong>
  </Wrapper>;

require("./single_membership.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./single_membership.js");